import React from "react"
import PropTypes from "prop-types"

import {
  StyledDuplaConfirmacao,
  Header,
  Title,
  CloseButton,
  ContentText,
  Footer,
  FooterButton,
} from "./DuplaConfirmacao.styled"

import { DialogContent } from "@mui/material"

import { ReactComponent as CloseIcon } from "src/v2/assets/icons/close-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { ReactComponent as CloseSquareIcon } from "src/v2/assets/icons/close-square-icon.svg"

const DuplaConfirmacao = ({ open, cancel, confirm, action = "excluir", description, title, confirmTextButton, cancelIcon, confirmIcon }) => {
  return (
    <StyledDuplaConfirmacao open={open} onClose={cancel}>
      
      <Header>
        <Title variant="h3">
          {title ?? "Dupla Confirmação"}
        </Title>
        <CloseButton onClick={cancel}>
          <CloseIcon style={{ width: 32, height: 32 }} />
        </CloseButton>
      </Header>

      <DialogContent sx={{ padding: "0 24px" }}>
        <ContentText variant="inherit">
          {description ?? (<>Você está certo de que deseja <strong>{action}</strong> este item?</>
          )}        
        </ContentText>
      </DialogContent>

      <Footer>
        <FooterButton onClick={cancel}>
          {cancelIcon ?? (
            <CloseSquareIcon style={{ width: 22, height: 22, color: "#E3A404" }} />
          )}
          CANCELAR
        </FooterButton>

        <FooterButton onClick={confirm}>
          {confirmIcon ?? (
            <CheckIcon style={{ width: 22, height: 22, color: "#E3A404" }} />
          )}
          {confirmTextButton ?? "CONFIRMAR"}
        </FooterButton>
      </Footer>
    </StyledDuplaConfirmacao>
  )
}

DuplaConfirmacao.propTypes = {
  open: PropTypes.bool,
  cancel: PropTypes.func,
  confirm: PropTypes.func,
  action: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
  confirmTextButton: PropTypes.string,
  cancelIcon: PropTypes.node,
  confirmIcon: PropTypes.node
}

export default DuplaConfirmacao
